import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom"; // Added useLocation
import axios from "axios";

const ToolsSection = () => {
  const [toolsData, setToolsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Get current route location
  const location = useLocation();
  const isAllToolsPage = location.pathname === "/user/all-tools";

  useEffect(() => {
    const fetchToolsData = async () => {
      try {
        const res = await axios.get("https://allyoutube-01-02d59d78beb5.herokuapp.com/api/tools-section");
        setToolsData(res.data.data);
      } catch (err) {
        console.error("Failed to fetch tools data", err);
        setError("Failed to load tools.");
      } finally {
        setLoading(false);
      }
    };
    fetchToolsData();
  }, []);

  if (loading) return <div className="text-center py-5 text-white"></div>;
  if (error || !toolsData) return null;

  return (
    <>
      <section
        className="collection-section padding-top padding-bottom"
        style={{ backgroundColor: toolsData.backgroundColor || "#0f0f1a" }}
      >
        <div className="container">
          <div className="section-header text-center mb-5">
            <p
              className="text-uppercase text-secondary fw-bold ls-2"
              style={{ letterSpacing: "2px" }}
            >
              {toolsData.sectionSubtitle}
            </p>
            <h2 className="text-white">{toolsData.sectionTitle}</h2>
          </div>

          <div className="section-wrapper">
            <div className="row g-4 justify-content-center">
              {toolsData.tools.map((tool) => (
                <div className="col-lg-3 col-md-4 col-sm-6" key={tool.id || tool.title}>
                  <div
                    className="saas-card h-100 p-4 position-relative overflow-hidden text-center"
                    style={{
                      background: "#161625",
                      borderRadius: "10px",
                      border: "1px solid rgba(255,255,255,0.05)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.borderColor = tool.color;
                      e.currentTarget.style.boxShadow = `0 10px 20px -10px ${tool.color}40`;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.borderColor = "rgba(255,255,255,0.05)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    {/* Top decorative bar */}
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "4px",
                        background: tool.color,
                      }}
                    ></div>

                    {/* Icon Area */}
                    <div className="saas-icon-wrapper mb-3 mt-2">
                      <i
                        className={`${tool.icon}`}
                        style={{
                          fontSize: "2.5rem",
                          color: tool.color,
                          filter: "drop-shadow(0 0 8px rgba(255,255,255,0.1))",
                        }}
                      ></i>
                    </div>

                    {/* Content */}
                    <h5 className="mb-2 fw-bold">
                      {/* CONDITIONAL LINK LOGIC */}
                      {isAllToolsPage ? (
                        /* If on /user/all-tools, show the clickable link */
                        <a
                          href={tool.link}
                          className="text-white text-decoration-none stretched-link"
                        >
                          {tool.title}
                        </a>
                      ) : (
                        /* If on Home page, just show text (link disabled) */
                        <span className="text-white text-decoration-none">
                          {tool.title}
                        </span>
                      )}
                    </h5>

                    {/* NEW: Credit Cost Badge */}
                    {tool.creditCost !== undefined && (
                      <span 
                        className="badge mb-3" 
                        style={{ 
                          backgroundColor: "rgba(255,255,255,0.1)", 
                          color: tool.color,
                          border: `1px solid ${tool.color}` 
                        }}
                      >
                        {tool.creditCost} Credits
                      </span>
                    )}

                    <p
                      className="text-secondary small mb-0"
                      style={{ lineHeight: "1.5" }}
                    >
                      {tool.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* CONDITIONAL BUTTON LOGIC */}
            {/* Only show 'Browse All Tools' if we are NOT on the all-tools page */}
            {!isAllToolsPage && (
              <div className="button-wrapper text-center mt-5">
                <Link to={toolsData.browseAllLink} className="default-button reverse-effect">
                  <span>
                    Browse All Tools <i className="icofont-circled-right" />
                  </span>
                </Link>
              </div>
            )}
            
          </div>
        </div>
      </section>
    </>
  );
};

export default ToolsSection;